import { useState, useEffect } from "react";
import { ChevronRight } from "@unified-checkout/design-system/icons/index";
import { Button } from "@unified-checkout/design-system";
import type { ICollapsibleSection } from "@app/dashboard/types/innerLayout/collapsible-section";
import styles from "./collapsible-section.module.scss";

export const CollapsibleSection = ({
  size = 'md',
  open = false,
  title,
  count,
  body,
  customCollapseIcon
}: ICollapsibleSection) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <div
      className={styles["collapsible-section"]}
      data-collapsible-section-open={isOpen}
      data-collapsible-section-size={size}
    >

      <div className={styles["collapsible-section__header"]}>

        <div className={styles["collapsible-section__header__title"]}>
          {title}

          {
            count &&
            <span className={styles["collapsible-section__header__title__count"]}>
              {` (${count})`}
            </span>
          }
        </div>

        <div className={styles["collapsible-section__header__chevron"]}>
          {
            customCollapseIcon ?
              <div
                className={styles["collapsible-section__header__custom-chevron"]}
                onClick={() => setIsOpen(!isOpen)}
              >
                {customCollapseIcon}
              </div>
              :
              <Button
                size="sm"
                color="secondary"
                variant="outlined"
                leadingIcon={ChevronRight}
                onClickHandler={() => setIsOpen(!isOpen)}
              />
          }
        </div>
      </div>

      {
        body && isOpen &&
        <div className={styles["collapsible-section__body"]}>
          {body}
        </div>
      }

    </div>
  )
}
